module.exports = __webpack_public_path__ + "img/filter-type-cooldown--active.4b5d3dda.svg";